var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuveniliricerik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8817 45.7704H32.1182C35.2042 45.7704 38.0557 44.1242 39.5987 41.454L46.217 29.9892C47.7599 27.3162 47.7599 24.0238 46.217 21.3508L39.5987 9.88598C38.0557 7.21578 35.2042 5.56958 32.1182 5.56958H18.8817C15.7957 5.56958 12.9442 7.21578 11.4012 9.88598L4.78291 21.3508C3.23995 24.0238 3.23995 27.3162 4.78291 29.9892L11.4012 41.454C12.9442 44.1242 15.7957 45.7704 18.8817 45.7704Z",
    stroke: "black",
    strokeWidth: 1.04166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.02 25.6699C25.02 22.8295 22.7181 20.5276 19.8777 20.5276C17.0401 20.5276 14.7383 22.8295 14.7383 25.6699C14.7383 28.5103 17.0401 30.8122 19.8777 30.8122C22.7181 30.8122 25.02 28.5103 25.02 25.6699Z",
    stroke: "black",
    strokeWidth: 1.04166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2616 25.6895H25.02",
    stroke: "black",
    strokeWidth: 1.04166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4949 28.7642V25.6895",
    stroke: "black",
    strokeWidth: 1.04166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuveniliricerik);
export default __webpack_public_path__ + "static/media/guveniliricerik.1e72c626b4a94dd3189569e9d0e227d8.svg";
export { ForwardRef as ReactComponent };